export const supportedLanguages = ["es", "en"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const toSupportedLanguage = (
  value: string | null | undefined,
): SupportedLanguage | null =>
  supportedLanguages.find((language) => language === value) ?? null;

export const resolveSupportedLanguage = (
  value: string | null | undefined,
): SupportedLanguage => (value?.toLowerCase().startsWith("en") ? "en" : "es");
